
export const config = {
  "defaultRefreshTime": 3600000,
  "enableMock": false,
  "excelDownloadUrl": ""
};
